<div *ngIf="router.url == '/idms/project-manager' && addNewProject && projecTypeList?.length">
    <div class="dropdown dropdown-inline ms-2" data-toggle="tooltip" title="Add New item" data-placement="left"
        placement="bottom-right" ngbDropdown>
        <a style="position: relative" class="btn primary-ebtn font-weight-bold py-3 px-6" aria-haspopup="true"
            aria-expanded="false" ngbDropdownToggle> {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }} </a>

        <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right" ngbDropdownMenu>
            <ul class="navi navi-hover py-5">
                <li class="navi-item" *ngFor="let ptype of projecTypeList">
                    <a class="navi-link cursor-pointer" (click)="open(ptype)">
                        <span class="navi-text" style="margin-left: 10px">{{ ptype.name }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div *ngIf="currentProjectTabName === 'Work Packs' && addNewWorkpack && activityPackTypes?.length">
    <div class="dropdown dropdown-inline ms-2" data-toggle="tooltip" title="Add New item" data-placement="left"
        placement="bottom-right" ngbDropdown>
        <a style="position: relative" class="btn primary-ebtn font-weight-bold py-3 px-6" aria-haspopup="true"
            aria-expanded="false" ngbDropdownToggle> Add </a>

        <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right" ngbDropdownMenu>
            <ul class="navi navi-hover py-5">
                <li class="navi-item" *ngFor="let atype of activityPackTypes">
                    <a class="navi-link cursor-pointer" (click)="open(atype)">
                        <span class="navi-text" style="margin-left: 10px">{{ atype.name }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>